const Style = {
    stack: 'space-y-6',
    nav: 'flex gap-3',
    navBtn: 'w-full',
};

export default Style;
